import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const CustomerPrivateRoute = () => {
  let isAuthenticated = false;
  try {
    const session = sessionStorage.getItem("aman-customer");
    if (session) {
      const parsed = JSON.parse(session);
      if (parsed && parsed.token && parsed.user) {
        isAuthenticated = true;
      }
    }
  } catch (e) {
    isAuthenticated = false;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/portal-login" replace />;
};

export default CustomerPrivateRoute;
